import request from "@/config/utils/request";

export function searchList(data) {
  return request({
    url: "/apis/demo/org/listSearchMember1",
    method: "post",
    data
  });
}
